import {
    Box,
    Paper,
    ToggleButton,
    ToggleButtonGroup,
    Tooltip,
    Typography,
} from "@mui/material"
import { alpha } from "@mui/material/styles"
import { Localized } from "@fluent/react"

import type { WorkflowViewMode } from "../documentWorkflowTypes"
import { viewModeConfig } from "../DocumentWorkflowConfig"

export type WorkflowViewSwitcherProps = {
    value: WorkflowViewMode
    onChange: (value: WorkflowViewMode) => void
}

export const WorkflowViewSwitcher = ({
    value,
    onChange,
}: WorkflowViewSwitcherProps) => {
    return (
        <Paper
            variant="outlined"
            sx={theme => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
                px: 1,
                py: 0.5,
                mb: 1.25,
                borderRadius: 2,
                bgcolor: alpha(theme.palette.info.main, 0.08),
                borderColor: alpha(theme.palette.info.main, 0.22),
            })}
        >
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                <Typography
                    sx={{
                        fontWeight: 700,
                        fontSize: 12,
                        lineHeight: 1.2,
                    }}
                >
                    <Localized id={viewModeConfig[value].labelId}>
                        <span>{viewModeConfig[value].labelFallback}</span>
                    </Localized>
                </Typography>
            </Box>

            <ToggleButtonGroup
                size="small"
                exclusive
                value={value}
                onChange={(_, nextValue: WorkflowViewMode | null) => {
                    if (nextValue) {
                        onChange(nextValue)
                    }
                }}
                sx={{
                    "& .MuiToggleButton-root": {
                        minWidth: 34,
                        px: 0.75,
                        py: 0.25,
                        border: 0,
                        borderRadius: 1,
                    },
                    "& .MuiToggleButtonGroup-grouped": {
                        mx: 0.25,
                        borderRadius: 1,
                    },
                }}
            >
                {(Object.keys(viewModeConfig) as WorkflowViewMode[])
                    .map(mode => (
                        <Tooltip
                            key={mode}
                            title={
                                <Localized id={viewModeConfig[mode].labelId}>
                                    <span>{viewModeConfig[mode].labelFallback}</span>
                                </Localized>
                            }
                        >
                            <ToggleButton
                                value={mode}
                                aria-label={viewModeConfig[mode].labelFallback}
                            >
                                {viewModeConfig[mode].icon}
                            </ToggleButton>
                        </Tooltip>
                    ))}
            </ToggleButtonGroup>
        </Paper>
    )
}